module.exports = __webpack_public_path__ + "img/gsgl1.9982d680.png";